module.exports = __webpack_public_path__ + "static/media/giftasticTextImage.1d05bc16.png";